import {
  Component,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

import { TypographyComponent } from '../typography/typography.component'

@Component({
  selector: 'hyperkit-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true,
    },
  ],
})
export class RadioButtonComponent implements ControlValueAccessor {
  @Input() public name = ''
  @Input() public disabled = false
  @Input() public text = ''
  @Input() public value: any

  @Input() public selected = false

  private onChange = (_: any) => {}
  protected onTouched = () => {}

  // Called when this radio button is selected
  public select(): void {
    if (this.disabled) return

    this.onChange(this.value)
    this.onTouched()
  }

  // ControlValueAccessor methods
  writeValue(obj: any): void {
    this.selected = obj === this.value
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
